import React, { useContext } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withChat } from '../../../chat';
import { withActiveClientsContextProvider } from '../../context/ActiveClientsContext';
import { withFeedContextProvider } from '../../context/FeedContext';
import { withChatContextProvider } from '../../context/ChatContext';
import { withOnboardingCoachNotificationsContextProvider } from '../../context/OnboardingCoachNotificationsContext';
import { withManageClientContextProvider } from '../../context/ManageClientContext';
import { withMealPlanContextProvider } from '../../context/MealPlanContext';
import { withCustomizationContextProvider } from '../../context/CustomizationContext';
import { withAnnouncementContextProvider } from '../../context/AnnouncementContext';
import { withManageProgramContextProvider } from '../../context/ManageProgramContext';
import { withManageTrackContextProvider } from '../../context/ManageTrackContext';
import { withWorkoutContextProvider } from '../../context/WorkoutContext';
import { withExerciseContextProvider } from '../../context/ExerciseContext';
import { withExerciseTagContextProvider } from '../../context/ExerciseTagContext';
import {
  withExternalCoachContextProvider,
  withExternalCoachContextReady,
} from '../../context/ExternalCoachContext';
import { withLeadsContextProvider } from '../../context/LeadsContext';
import withChatProps from '../../pages/Chat/withChatProps';
import QAPContext, { withQAPContextProvider } from '../../../context/QAPContext';
import { withPrimaryContextsReadyContext } from '../../context/PrimaryContextsReadyContext';
import { withSecondaryContextsReadyContext } from '../../context/SecondaryContextsReadyContext';
import ToolsLayout from '../ToolsLayout';
import ClientQuickInfoModal from '../../components/ClientQuickInfoModal';
import CoachSidebar from './CoachSidebar';

const CoachToolsLayout = ({
  children,
}) => {
  const { isOpen: showQAP } = useContext(QAPContext);

  return (
    <ToolsLayout sidebarComponent={<CoachSidebar />}>
      {children}
      {showQAP && <ClientQuickInfoModal />}
    </ToolsLayout>
  );
};

CoachToolsLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

// Don't put any ready context providers here unless you want them to be ready for all coach tools pages!
export default compose(
  // Order of external chat context,feed context, and external coach context is important here!
  withChatProps,
  withChat,
  // Shared active-client roster. Must stay above both the feed and manage-client providers, which consume it.
  withActiveClientsContextProvider,
  withFeedContextProvider,
  withExternalCoachContextProvider,
  withExternalCoachContextReady,
  withChatContextProvider,
  withMealPlanContextProvider,
  withOnboardingCoachNotificationsContextProvider,
  withLeadsContextProvider,
  withQAPContextProvider,
  /**
   * This context is placed after all the critical primary contexts. It makes sure all of the primary contexts are
   * ready, so that the deferred contexts are only initialized after that. Only add critical contexts above this one.
   */
  withPrimaryContextsReadyContext,
  withManageProgramContextProvider,
  withManageTrackContextProvider,
  withWorkoutContextProvider,
  /**
   * This context is placed after the "secondary" contexts. It ensures the remaining deferred contexts are only
   * initialized after these are ready. At this point all contexts required for AC action items would be ready.
   */
  withSecondaryContextsReadyContext,
  withManageClientContextProvider,
  withCustomizationContextProvider,
  withAnnouncementContextProvider,
  withExerciseContextProvider,
  withExerciseTagContextProvider,
)(CoachToolsLayout);
